import { Observable } from 'rxjs';
import { ParamsKey } from '../router';

export interface ValidationFaultDto {
    field?: string;
    msg?: string;
    params?: any;
    debug?: any;
}

export interface DeleteDlgData {
    title: string;
    hint: string;
}

export interface FilterGroup {
    title?: string;
    controls: FilterControl[];
}

export interface FilterControl {
    [FilterControlKeys.type]: FilterType;
    [FilterControlKeys.label]: string;
    [FilterControlKeys.paramsKey]: ParamsKey;
    [FilterControlKeys.options]?: SelectOption[];
    [FilterControlKeys.value]?: any;
}

export enum FilterType {
    SEARCH = 'SEARCH',
    SELECTION = 'SELECTION',
    DATE_PICKER = 'DATE_PICKER',
}

export enum FilterControlKeys {
    type = 'type',
    label = 'label',
    paramsKey = 'paramsKey',
    options = 'options',
    value = 'value',
}
export interface SelectedFilter {
    label: string;
    value: string;
    paramsKey: ParamsKey;
}

export interface SelectOption {
    value: any;
    label: string;
}

export interface MenuAction {
    label: string;
    event: string;
}
